// 全局配置文件
export default {
  // 后端服务器地址（用于图片等静态资源）
  // 与 API 请求共用运行时配置(window.APP_CONFIG.BASE_URL)，打包后只需改 dist/config.js 一处即可同时切换接口与图片地址
  baseURL: (typeof window !== 'undefined' && window.APP_CONFIG && window.APP_CONFIG.BASE_URL) ? window.APP_CONFIG.BASE_URL : '/dev-api'
}